import React from 'react';
import LongText from '../Elements/LongText';

export default class CommissionLineItem {
  constructor(item) {
    if (item === undefined) {
      this.ClientId = null;
      this.ClientName = null;
      this.OpportunityId = null;
      this.OpportunityName = null;
      this.ServiceId = null;
      this.ServiceName = null;
      this.CommissionedUserId = null;
      this.commissionedExternalSalesPartnerId = null;
      this.CommissionedEntityName = null;
      this.CurrencyId = null;
      this.CurrencyCode = null;
      this.CommissionValue = null;
      return;
    }
    this.ClientId = item.clientId;
    this.ClientName = item.clientName;
    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.ServiceId = item.serviceId;
    this.ServiceName = item.serviceName;
    this.CommissionedUserId = item.commissionedUserId;
    this.CommissionedExternalSalesPartnerId = item.commissionedExternalSalesPartnerId;
    this.CommissionedEntityName = item.commissionedUserId
      ? `${item.commissionedUserLastName}, ${item.commissionedUserFirstName} (${item.commissionedUserId})`
      : `${item.commissionedExternalSalesPartnerName} (${item.commissionedExternalSalesPartnerId})`;
    this.CurrencyId = item.currencyId;
    this.CurrencyCode = item.currencyCode;
    this.CommissionValue = item.commissionValue;
  }

  static MoneyFields = ['CommissionValue'];

  static Currency() {
    return 'CurrencyCode';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Name (ID)', orderById: 'CommissionedEntityName', data: 'CommissionedEntityName' },
      { label: 'Opportunity ID', orderById: 'OpportunityId', data: CommissionLineItem.GetOpportunityCellContent },
      { label: 'Service ID', orderById: 'ServiceId', data: CommissionLineItem.GetDetailCellContent },
      { label: 'Currency', orderById: 'CurrencyCode', data: 'CurrencyCode' },
      { label: 'Commission Amount', orderById: 'CommissionValue', data: 'CommissionValue' },
    ];
  }

  static GetOpportunityCellContent(item) {
    return (
      <LongText
        text={`${item.OpportunityName} (${item.OpportunityId})`}
        maxLength={75}
      />
    );
  }

  static GetDetailCellContent(item) {
    return (
      <span
        className='secondarylink'
        onClick={(e) => CommissionLineItem.changeTab(item)}
      >
        <LongText
          text={`${item.ServiceName} (${item.ServiceId})`}
          maxLength={75}
        />
      </span>
    );
  }

  static changeTab(item) {
    window.alert('Not implemented yet');
  }
}
